var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProduction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.8466 5.1499H13.9866C9.56829 5.1499 5.98657 8.73162 5.98657 13.1499V55.01C5.98657 59.4283 9.56829 63.01 13.9866 63.01H55.8466C60.2648 63.01 63.8466 59.4283 63.8466 55.01V13.1499C63.8466 8.73162 60.2648 5.1499 55.8466 5.1499Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8566 0.0100098H8.99658C4.5783 0.0100098 0.996582 3.59173 0.996582 8.01001V49.8701C0.996582 54.2884 4.5783 57.8701 8.99658 57.8701H50.8566C55.2748 57.8701 58.8566 54.2884 58.8566 49.8701V8.01001C58.8566 3.59173 55.2748 0.0100098 50.8566 0.0100098Z",
    fill: "url(#paint0_linear_15_68)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7766 35.74H19.8866C19.1172 35.74 18.3651 35.9681 17.7254 36.3955C17.0857 36.8229 16.5871 37.4306 16.2927 38.1414C15.9983 38.8522 15.9212 39.6343 16.0713 40.3889C16.2214 41.1435 16.5919 41.8366 17.136 42.3806C17.68 42.9246 18.3731 43.2952 19.1277 43.4453C19.8823 43.5954 20.6644 43.5183 21.3752 43.2239C22.086 42.9295 22.6936 42.431 23.121 41.7913C23.5484 41.1516 23.7766 40.3993 23.7766 39.6299V18.24L39.3266 14.3501V35.74C39.3266 36.5094 39.0984 37.2614 38.671 37.9011C38.2436 38.5408 37.6361 39.0396 36.9253 39.334C36.2145 39.6284 35.4323 39.7053 34.6777 39.5552C33.9231 39.4051 33.23 39.0347 32.6859 38.4907C32.1419 37.9467 31.7715 37.2534 31.6214 36.4988C31.4713 35.7442 31.5483 34.9623 31.8427 34.2515C32.1371 33.5407 32.6357 32.9331 33.2754 32.5056C33.9151 32.0782 34.6673 31.8501 35.4366 31.8501H39.3266",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_68",
    x1: 3.33658,
    y1: 55.5201,
    x2: 56.5067,
    y2: 2.35013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/production.085b0b8bdf3dacf6fc3b463409f7662b.svg";
export { ForwardRef as ReactComponent };